import { useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth, useDroits } from '../auth';
import { useApi } from '../hooks';
import Logo from './Logo';
import Icone from './icones';

const ROLES = { SUPER_ADMIN: 'Super administrateur', ADMIN: 'Administrateur', SUPPORT: 'Support' };

export default function Layout() {
  const { utilisateur, deconnexion } = useAuth();
  const { superAdmin } = useDroits();
  const { pathname } = useLocation();
  const { donnees: compteur, recharger } = useApi('/mises-a-jour/compteur');

  // Le badge est actualisé à chaque changement de page et toutes les 30 secondes
  useEffect(() => {
    recharger();
  }, [pathname, recharger]);
  useEffect(() => {
    const minuteur = setInterval(recharger, 30_000);
    return () => clearInterval(minuteur);
  }, [recharger]);
  const enAttente = compteur?.enAttente ?? 0;

  const liens = [
    ['/', 'Tableau de bord', 'tableau'],
    ['/clients', 'Clients', 'clients'],
    ['/postes', 'Postes', 'postes'],
    ['/logiciels', 'Logiciels', 'logiciels'],
    ['/mises-a-jour', 'Mises à jour', 'misesAJour', enAttente],
    ['/historique', 'Historique', 'historique'],
    ...(superAdmin ? [['/utilisateurs', 'Utilisateurs', 'utilisateurs']] : []),
  ];

  const nom = [utilisateur.firstName, utilisateur.lastName].filter(Boolean).join(' ') || utilisateur.username;
  const initiales = nom
    .split(/\s+/)
    .map((mot) => mot[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="app">
      <aside className="menu">
        <div className="marque">
          <Logo taille={34} />
          <div>
            <div className="marque-nom">SoftManage</div>
            <div className="marque-sous-titre">Expertise comptable</div>
          </div>
        </div>
        <div className="menu-section">Navigation</div>
        <nav>
          {liens.map(([chemin, libelle, icone, badge]) => (
            <NavLink key={chemin} to={chemin} end={chemin === '/'} className="menu-lien">
              <Icone nom={icone} />
              <span className="menu-libelle">{libelle}</span>
              {badge > 0 && <span className="menu-badge">{badge}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="menu-utilisateur">
          <div className="avatar">{initiales}</div>
          <div className="menu-identite">
            <strong>{nom}</strong>
            <div className="menu-role">{ROLES[utilisateur.role] || utilisateur.role}</div>
          </div>
          <button className="btn-deconnexion" onClick={deconnexion} title="Déconnexion" aria-label="Déconnexion">
            <Icone nom="sortie" />
          </button>
        </div>
      </aside>
      <main className="contenu">
        <Outlet />
      </main>
    </div>
  );
}
